import { createStore } from "vuex";
import { config } from "vuex-module-decorators";
config.rawError = true;
import AuthModule from "@/store/modules/AuthModule";
import BodyModule from "@/store/modules/BodyModule";
import BreadcrumbsModule from "@/store/modules/BreadcrumbsModule";
import Cad_CalendarioModule from "@/store/modules/cad/CalendarioModule";
import Cad_CNAEModule from "@/store/modules/cad/CNAEModule";
import Cad_Formas_de_PagamentoModule from "@/store/modules/cad/Formas_de_PagamentoModule";
import Cad_MaterialModule from "@/store/modules/cad/MaterialModule";
import Cad_MoedaModule from "@/store/modules/cad/MoedaModule";
import Cad_SituacaoModule from "@/store/modules/cad/SituacaoModule";
import Cad_Status_MaterialModule from "@/store/modules/cad/Status_MaterialModule";
import Cad_Time_ColaboradorModule from "@/store/modules/cad/Time_ColaboradorModule";
import Cad_Tipo_MaterialModule from "@/store/modules/cad/Tipo_MaterialModule";
import Chm_CampoModule from "@/store/modules/chm/CampoModule";
import Chm_Campo_Etapa_ChamadoModule from "@/store/modules/chm/Campo_Etapa_ChamadoModule";
import Chm_ChamadoModule from "@/store/modules/chm/ChamadoModule";
import Chm_Etapa_ChamadoModule from "@/store/modules/chm/Etapa_ChamadoModule";
import Chm_GrupoModule from "@/store/modules/chm/GrupoModule";
import Chm_Grupo_SetorModule from "@/store/modules/chm/Grupo_SetorModule";
import Chm_Grupo_Setor_Etapa_ChamadoModule from "@/store/modules/chm/Grupo_Setor_Etapa_ChamadoModule";
import Chm_Grupo_Setor_Projeto_ClienteModule from "@/store/modules/chm/Grupo_Setor_Projeto_ClienteModule";
import Chm_Grupo_Setor_UsuarioModule from "@/store/modules/chm/Grupo_Setor_UsuarioModule";
import Chm_IteracaoModule from "@/store/modules/chm/IteracaoModule";
import Chm_Responsavel_ChamadoModule from "@/store/modules/chm/Responsavel_ChamadoModule";
import Chm_Seguidor_ChamadoModule from "@/store/modules/chm/Seguidor_ChamadoModule";
import Chm_SetorModule from "@/store/modules/chm/SetorModule";
import Chm_SLAModule from "@/store/modules/chm/SLAModule";
import Chm_Status_ChamadoModule from "@/store/modules/chm/Status_ChamadoModule";
import Chm_Template_ChamadoModule from "@/store/modules/chm/Template_ChamadoModule";
import Chm_Tipo_CampoModule from "@/store/modules/chm/Tipo_CampoModule";
import Chm_Tipo_ChamadoModule from "@/store/modules/chm/Tipo_ChamadoModule";
import Chm_Valor_CampoModule from "@/store/modules/chm/Valor_CampoModule";
import ConfigModule from "@/store/modules/ConfigModule";
import Cont_Centro_CustoModule from "@/store/modules/cont/Centro_CustoModule";
import Cont_ContasModule from "@/store/modules/cont/ContasModule";
import Cont_DespesasModule from "@/store/modules/cont/DespesasModule";
import Cont_Material_DetalhesModule from "@/store/modules/cont/Material_DetalhesModule";
import Cont_Material_ItensModule from "@/store/modules/cont/Material_ItensModule";
import Cont_PertencesModule from "@/store/modules/cont/PertencesModule";
import Cont_Plano_ContasModule from "@/store/modules/cont/Plano_ContasModule";
import Cont_Plano_Contas_TipoModule from "@/store/modules/cont/Plano_Contas_TipoModule";
import Fornec_AdendosModule from "@/store/modules/fornec/AdendosModule";
import Fornec_Adendo_ColaboradorModule from "@/store/modules/fornec/Adendo_ColaboradorModule";
import Fornec_CargoModule from "@/store/modules/fornec/CargoModule";
import Fornec_CategoriaModule from "@/store/modules/fornec/CategoriaModule";
import Fornec_Categoria_CNHModule from "@/store/modules/fornec/Categoria_CNHModule";
import Fornec_Categoria_CustoModule from "@/store/modules/fornec/Categoria_CustoModule";
import Fornec_Categoria_ReembolsoModule from "@/store/modules/fornec/Categoria_ReembolsoModule";
import Fornec_CNAE_FornecedorModule from "@/store/modules/fornec/CNAE_FornecedorModule";
import Fornec_ColaboradorModule from "@/store/modules/fornec/ColaboradorModule";
import Fornec_ContratosModule from "@/store/modules/fornec/ContratosModule";
import Fornec_DiariaModule from "@/store/modules/fornec/DiariaModule";
import Fornec_Estado_CivilModule from "@/store/modules/fornec/Estado_CivilModule";
import Fornec_Fornecedor_ClienteModule from "@/store/modules/fornec/Fornecedor_ClienteModule";
import Fornec_Grau_ExperienciaModule from "@/store/modules/fornec/Grau_ExperienciaModule";
import Fornec_Grau_InstrucaoModule from "@/store/modules/fornec/Grau_InstrucaoModule";
import Fornec_Horas_AdicionaisModule from "@/store/modules/fornec/Horas_AdicionaisModule";
import Fornec_Limites_ReembolsoModule from "@/store/modules/fornec/Limites_ReembolsoModule";
import Fornec_Material_ColaboradorModule from "@/store/modules/fornec/Material_ColaboradorModule";
import Fornec_Orgao_EmissorModule from "@/store/modules/fornec/Orgao_EmissorModule";
import Fornec_Projeto_ClienteModule from "@/store/modules/fornec/Projeto_ClienteModule";
import Fornec_Projeto_ColaboradorModule from "@/store/modules/fornec/Projeto_ColaboradorModule";
import Fornec_ReembolsoModule from "@/store/modules/fornec/ReembolsoModule";
import Fornec_Restritivos_ReembolsoModule from "@/store/modules/fornec/Restritivos_ReembolsoModule";
import Fornec_Status_DiariaModule from "@/store/modules/fornec/Status_DiariaModule";
import Fornec_Status_ReembolsoModule from "@/store/modules/fornec/Status_ReembolsoModule";
import Fornec_TimesheetModule from "@/store/modules/fornec/TimesheetModule";
import Fornec_Tipo_ReembolsoModule from "@/store/modules/fornec/Tipo_ReembolsoModule";
import Infra_EmpresaModule from "@/store/modules/infra/EmpresaModule";
import Infra_EstadoModule from "@/store/modules/infra/EstadoModule";
import Infra_Fuso_HorarioModule from "@/store/modules/infra/Fuso_HorarioModule";
import Infra_InformativoModule from "@/store/modules/infra/InformativoModule";
import Infra_Informativo_MicroServicosModule from "@/store/modules/infra/Informativo_MicroServicosModule";
import Infra_Informativo_UnidadeModule from "@/store/modules/infra/Informativo_UnidadeModule";
import Infra_InterceptorModule from "@/store/modules/infra/InterceptorModule";
import Infra_MenuModule from "@/store/modules/infra/MenuModule";
import Infra_MicroServicosModule from "@/store/modules/infra/MicroServicosModule";
import Infra_PaisModule from "@/store/modules/infra/PaisModule";
import Infra_RegiaoModule from "@/store/modules/infra/RegiaoModule";
import Infra_RoleModule from "@/store/modules/infra/RoleModule";
import Infra_RotasModule from "@/store/modules/infra/RotasModule";
import Infra_TasksModule from "@/store/modules/infra/TasksModule";
import Infra_Tipo_AutenticacaoModule from "@/store/modules/infra/Tipo_AutenticacaoModule";
import Infra_Tipo_InformativoModule from "@/store/modules/infra/Tipo_InformativoModule";
import Infra_TurmaModule from "@/store/modules/infra/TurmaModule";
import Infra_UnidadeModule from "@/store/modules/infra/UnidadeModule";
import Infra_UsuarioModule from "@/store/modules/infra/UsuarioModule";
import Infra_Usuario_UnidadeModule from "@/store/modules/infra/Usuario_UnidadeModule";
import Infra_Usuario_Unidade_RoleModule from "@/store/modules/infra/Usuario_Unidade_RoleModule";
import Infra_UtilsModule from "@/store/modules/infra/UtilsModule";
import Mtz_AreaModule from "@/store/modules/mtz/AreaModule";
import Mtz_AtividadeModule from "@/store/modules/mtz/AtividadeModule";
import Mtz_CargoModule from "@/store/modules/mtz/CargoModule";
import Mtz_ChecklistColaboradorModule from "@/store/modules/mtz/ChecklistColaboradorModule";
import Mtz_ChecklistModule from "@/store/modules/mtz/ChecklistModule";
import Mtz_ChecklistPerguntaModule from "@/store/modules/mtz/ChecklistPerguntaModule";
import Mtz_Colaborador_AvaliacaoModule from "@/store/modules/mtz/Colaborador_AvaliacaoModule";
import Mtz_ConhecimentoModule from "@/store/modules/mtz/ConhecimentoModule";
import Mtz_DashboardMTZModule from "@/store/modules/mtz/DashboardMTZModule";
import Mtz_EquipeModule from "@/store/modules/mtz/EquipeModule";
import Mtz_FuncaoModule from "@/store/modules/mtz/FuncaoModule";
import Mtz_Lista_PresencaModule from "@/store/modules/mtz/Lista_PresencaModule";
import Mtz_Nivel_HabilidadeModule from "@/store/modules/mtz/Nivel_HabilidadeModule";
import Mtz_PerguntaModule from "@/store/modules/mtz/PerguntaModule";
import Mtz_ResponsabilidadeModule from "@/store/modules/mtz/ResponsabilidadeModule";
import Mtz_Responsabilidade_AtividadeModule from "@/store/modules/mtz/Responsabilidade_AtividadeModule";
import Mtz_RespostaChecklistModule from "@/store/modules/mtz/RespostaChecklistModule";
import Mtz_TemaModule from "@/store/modules/mtz/TemaModule";
import Mtz_Tipo_ContratacaoModule from "@/store/modules/mtz/Tipo_ContratacaoModule";
import Mtz_TreinamentoModule from "@/store/modules/mtz/TreinamentoModule";
import Mtz_Treinamento_ColaboradorModule from "@/store/modules/mtz/Treinamento_ColaboradorModule";
import Mtz_Treinamento_ConhecimentoModule from "@/store/modules/mtz/Treinamento_ConhecimentoModule";
import Report_ReportModule from "@/store/modules/Report/ReportModule";
import Rot_Acoes_CorretivasModule from "@/store/modules/rot/Acoes_CorretivasModule";
import Rot_Acoes_Corretivas_StatusModule from "@/store/modules/rot/Acoes_Corretivas_StatusModule";
import Rot_AnomaliaModule from "@/store/modules/rot/AnomaliaModule";
import Rot_Campo_Fluxo_InspecaoModule from "@/store/modules/rot/Campo_Fluxo_InspecaoModule";
import Rot_Campo_TipoModule from "@/store/modules/rot/Campo_TipoModule";
import Rot_Etapa_Fluxo_InspecaoModule from "@/store/modules/rot/Etapa_Fluxo_InspecaoModule";
import Rot_Fluxo_InspecaoModule from "@/store/modules/rot/Fluxo_InspecaoModule";
import Rot_InspecaoModule from "@/store/modules/rot/InspecaoModule";
import Rot_Inspecao_Anomalia_StatusModule from "@/store/modules/rot/Inspecao_Anomalia_StatusModule";
import Rot_Inspecao_RespostaModule from "@/store/modules/rot/Inspecao_RespostaModule";
import Rot_Inspecao_Resposta_AnomaliaModule from "@/store/modules/rot/Inspecao_Resposta_AnomaliaModule";
import Rot_Inspecao_Resposta_FotosModule from "@/store/modules/rot/Inspecao_Resposta_FotosModule";
import Rot_Inspecao_StatusModule from "@/store/modules/rot/Inspecao_StatusModule";
import Rot_Join_Fluxo_Inspecao_CampoModule from "@/store/modules/rot/Join_Fluxo_Inspecao_CampoModule";
import Rot_PrioridadeModule from "@/store/modules/rot/PrioridadeModule";
import Rot_QuestaoModule from "@/store/modules/rot/QuestaoModule";
import Rot_Questao_OpcaoModule from "@/store/modules/rot/Questao_OpcaoModule";
import Rot_RoteiroModule from "@/store/modules/rot/RoteiroModule";
import Rot_Roteiro_GrupoModule from "@/store/modules/rot/Roteiro_GrupoModule";
import TotalizerModule from "@/store/modules/TotalizerModule";
const store = createStore({
    modules: {
        AuthModule,
        BodyModule,
        BreadcrumbsModule,
        Cad_CalendarioModule,
        Cad_CNAEModule,
        Cad_Formas_de_PagamentoModule,
        Cad_MaterialModule,
        Cad_MoedaModule,
        Cad_SituacaoModule,
        Cad_Status_MaterialModule,
        Cad_Time_ColaboradorModule,
        Cad_Tipo_MaterialModule,
        Chm_CampoModule,
        Chm_Campo_Etapa_ChamadoModule,
        Chm_ChamadoModule,
        Chm_Etapa_ChamadoModule,
        Chm_GrupoModule,
        Chm_Grupo_SetorModule,
        Chm_Grupo_Setor_Etapa_ChamadoModule,
        Chm_Grupo_Setor_Projeto_ClienteModule,
        Chm_Grupo_Setor_UsuarioModule,
        Chm_IteracaoModule,
        Chm_Responsavel_ChamadoModule,
        Chm_Seguidor_ChamadoModule,
        Chm_SetorModule,
        Chm_SLAModule,
        Chm_Status_ChamadoModule,
        Chm_Template_ChamadoModule,
        Chm_Tipo_CampoModule,
        Chm_Tipo_ChamadoModule,
        Chm_Valor_CampoModule,
        ConfigModule,
        Cont_Centro_CustoModule,
        Cont_ContasModule,
        Cont_DespesasModule,
        Cont_Material_DetalhesModule,
        Cont_Material_ItensModule,
        Cont_PertencesModule,
        Cont_Plano_ContasModule,
        Cont_Plano_Contas_TipoModule,
        Fornec_AdendosModule,
        Fornec_Adendo_ColaboradorModule,
        Fornec_CargoModule,
        Fornec_CategoriaModule,
        Fornec_Categoria_CNHModule,
        Fornec_Categoria_CustoModule,
        Fornec_Categoria_ReembolsoModule,
        Fornec_CNAE_FornecedorModule,
        Fornec_ColaboradorModule,
        Fornec_ContratosModule,
        Fornec_DiariaModule,
        Fornec_Estado_CivilModule,
        Fornec_Fornecedor_ClienteModule,
        Fornec_Grau_ExperienciaModule,
        Fornec_Grau_InstrucaoModule,
        Fornec_Horas_AdicionaisModule,
        Fornec_Limites_ReembolsoModule,
        Fornec_Material_ColaboradorModule,
        Fornec_Orgao_EmissorModule,
        Fornec_Projeto_ClienteModule,
        Fornec_Projeto_ColaboradorModule,
        Fornec_ReembolsoModule,
        Fornec_Restritivos_ReembolsoModule,
        Fornec_Status_DiariaModule,
        Fornec_Status_ReembolsoModule,
        Fornec_TimesheetModule,
        Fornec_Tipo_ReembolsoModule,
        Infra_EmpresaModule,
        Infra_EstadoModule,
        Infra_Fuso_HorarioModule,
        Infra_InformativoModule,
        Infra_Informativo_MicroServicosModule,
        Infra_Informativo_UnidadeModule,
        Infra_InterceptorModule,
        Infra_MenuModule,
        Infra_MicroServicosModule,
        Infra_PaisModule,
        Infra_RegiaoModule,
        Infra_RoleModule,
        Infra_RotasModule,
        Infra_TasksModule,
        Infra_Tipo_AutenticacaoModule,
        Infra_Tipo_InformativoModule,
        Infra_TurmaModule,
        Infra_UnidadeModule,
        Infra_UsuarioModule,
        Infra_Usuario_UnidadeModule,
        Infra_Usuario_Unidade_RoleModule,
        Infra_UtilsModule,
        Mtz_AreaModule,
        Mtz_AtividadeModule,
        Mtz_CargoModule,
        Mtz_ChecklistColaboradorModule,
        Mtz_ChecklistModule,
        Mtz_ChecklistPerguntaModule,
        Mtz_Colaborador_AvaliacaoModule,
        Mtz_ConhecimentoModule,
        Mtz_DashboardMTZModule,
        Mtz_EquipeModule,
        Mtz_FuncaoModule,
        Mtz_Lista_PresencaModule,
        Mtz_Nivel_HabilidadeModule,
        Mtz_PerguntaModule,
        Mtz_ResponsabilidadeModule,
        Mtz_Responsabilidade_AtividadeModule,
        Mtz_RespostaChecklistModule,
        Mtz_TemaModule,
        Mtz_Tipo_ContratacaoModule,
        Mtz_TreinamentoModule,
        Mtz_Treinamento_ColaboradorModule,
        Mtz_Treinamento_ConhecimentoModule,
        Report_ReportModule,
        Rot_Acoes_CorretivasModule,
        Rot_Acoes_Corretivas_StatusModule,
        Rot_AnomaliaModule,
        Rot_Campo_Fluxo_InspecaoModule,
        Rot_Campo_TipoModule,
        Rot_Etapa_Fluxo_InspecaoModule,
        Rot_Fluxo_InspecaoModule,
        Rot_InspecaoModule,
        Rot_Inspecao_Anomalia_StatusModule,
        Rot_Inspecao_RespostaModule,
        Rot_Inspecao_Resposta_AnomaliaModule,
        Rot_Inspecao_Resposta_FotosModule,
        Rot_Inspecao_StatusModule,
        Rot_Join_Fluxo_Inspecao_CampoModule,
        Rot_PrioridadeModule,
        Rot_QuestaoModule,
        Rot_Questao_OpcaoModule,
        Rot_RoteiroModule,
        Rot_Roteiro_GrupoModule,
        TotalizerModule,
    }
});
export default store;
//# sourceMappingURL=index.js.map